import React from "react";

const AdminSearchBar = ({ value, onChange, placeholder = "Cari..." }) => {
  return (
    <div className="relative mb-5">
      <svg
        className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400 pointer-events-none"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full pl-12 pr-4 py-3 rounded-2xl bg-white border border-slate-200 shadow-soft focus:border-brand-400 focus:ring-2 focus:ring-brand-100 outline-none transition-all font-overpass text-slate-800 placeholder:text-slate-400"
      />
    </div>
  );
};

export default AdminSearchBar;
